// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_fc-0";
export var optionCard = "_fc-1";